import React from "react";
import { Draggable, DraggableProvided, DraggableStateSnapshot } from "react-beautiful-dnd";
import { isFunction } from "lodash";

export interface DraggableRowProps {
	draggableId: string;
	index: number;
	key: string;
	children: (draggableContext: {
		provided: DraggableProvided;
		snapshot: DraggableStateSnapshot;
	}) => React.ReactNode | React.ReactNode;
	useDragHandle?: boolean;
}

const DraggableRow: React.FC<DraggableRowProps> = ({
	children,
	key,
	draggableId,
	index,
	useDragHandle = false,
	...props
}) => {
	return (
		<Draggable key={key} draggableId={draggableId} index={index}>
			{(provided, snapshot) => {
				const handleProps = useDragHandle ? {} : { ...provided.dragHandleProps };
				return (
					<div
						ref={provided.innerRef}
						{...provided.draggableProps}
						{...handleProps}
						className={`draggable-row${snapshot.isDragging ? " is-dragging" : ""}${
							useDragHandle ? "" : "cursor-move"
						}`}
						style={provided.draggableProps.style}
					>
						{isFunction(children)
							? children({
									provided,
									snapshot,
							  })
							: children}
					</div>
				);
			}}
		</Draggable>
	);
};

export default DraggableRow;
